var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable react/no-multi-comp */
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { createColumnHelper } from '@tanstack/react-table';
import RenderIfVisible from 'react-render-if-visible';
import { Translate } from "../../../../../I18N";

import { Button, Pill, Table } from "../../../../Components/UI";
import { FormInput } from "./FormInput";


















const LanguageHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Language");
const StatusHeader = () => /*#__PURE__*/_jsx(Translate, { className: "sr-only" }, void 0, "Language Code");
const FieldKeyHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Value");
const ActionHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Action");
const LabelHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Name");
const TypeHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Type");

const RenderButton = ({ cell }) => /*#__PURE__*/
_jsx(Link, { to: `edit/${cell.row.original.id}` }, void 0, /*#__PURE__*/
_jsx(Button, { styling: "outline", className: "leading-4" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Translate")
)
);


const ContextPill = ({ cell }) => /*#__PURE__*/
_jsx("div", { className: "whitespace-nowrap" }, void 0, /*#__PURE__*/
_jsx(Pill, { color: "gray" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, cell.renderValue())
)
);


const LanguagePill = ({ cell }) => {var _cell$getValue$langua;
  let color = 'gray';
  if (cell.getValue().status === 'defaultLanguage') color = 'primary';
  if (cell.getValue().status === 'untranslated') color = 'yellow';

  return /*#__PURE__*/_jsx(Pill, { color: color }, void 0, (_cell$getValue$langua = cell.getValue().languageKey) === null || _cell$getValue$langua === void 0 ? void 0 : _cell$getValue$langua.toUpperCase());
};

const TranslationsTables = ({
  tablesData,
  register,
  setValue,
  submitting,
  getFieldState
}) => {
  const memoizedInput = useMemo(
    () => (data) => FormInput(data, { register, setValue, submitting, getFieldState }),
    [getFieldState, register, setValue, submitting]
  );

  const columnHelper = createColumnHelper();

  const columns = [
  columnHelper.accessor('language', {
    header: LanguageHeader,
    enableSorting: false
  }),

  columnHelper.accessor('translationStatus', {
    header: StatusHeader,
    cell: LanguagePill,
    enableSorting: false
  }),
  columnHelper.accessor('fieldKey', {
    header: FieldKeyHeader,
    cell: memoizedInput,
    enableSorting: false,
    meta: { className: 'w-full' }
  })];


  return /*#__PURE__*/(
    React.createElement(React.Fragment, null,
    tablesData.map((data) => {
      if (data) {
        const [contextTerm] = Object.keys(data);
        return /*#__PURE__*/(
          _jsx("div", { className: "mt-4" }, contextTerm, /*#__PURE__*/
          _jsx(RenderIfVisible, { stayRendered: true }, void 0, /*#__PURE__*/
          _jsx(Table, { columns: columns, data: data[contextTerm], title: contextTerm })
          )
          ));

      }

      return undefined;
    })
    ));

};

export { RenderButton, ContextPill, TranslationsTables, ActionHeader, LabelHeader, TypeHeader };